import {IconProps} from "../icons";


export const MenuDownIcon = ({width = 24, height = 24, color}: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5.5L8 9.5L12 5.5H4Z" fill={color}/>
    </svg>
  )
}